<div id="mainInsuranceContainer" class="main-container" data-cy="patient-portal-insurance-main-container">

  @if (!isLoading) {
    <div class="information-object" data-cy="patient-portal-insurance-info-object-container">
      <div class="information-container mat-elevation-z2" data-cy="patient-portal-insurance-form-container">
        <div class="has-insurance-container" data-cy="patient-portal-insurance-checkbox-container">
          <mat-checkbox [(ngModel)]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-no-insurance-checkbox-input">I do not have insurance</mat-checkbox>
        </div>
        <div class="input-field input-field-full" [class.min-image]="tmpCardObj.InsuranceHasInsurance"
          (click)="activateImageView()" data-cy="patient-portal-insurance-image-view-container">
            <app-file-manager-view #imageView [width]="getFileViewWidth()" [height]="200" [roundImage]="false"
              [orientation]="'horizontal'" [viewType]="'single'" [DocumentGroupId]="documentGroup.DocumentGroupID"
              [enumDocumentTags]="[DOCUMENT_TAG.CopyofPatientInsuranceCard]" [PatientId]="PatientId"
              enumDocumentTypeID="0000001C-1000-0000-0000-000000000003" data-cy="patient-portal-insurance-file-manager-view"></app-file-manager-view>
        </div>
        <mat-form-field class="input-field input-field-full" data-cy="patient-portal-insurance-company-form-field">
          <mat-label data-cy="patient-portal-insurance-company-label">Insurance Company</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.InsuranceCompanyName" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-company-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-full" data-cy="patient-portal-insurance-address-form-field">
          <mat-label data-cy="patient-portal-insurance-address-label">Address</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.InsuranceAddress" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-address-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-full" data-cy="patient-portal-insurance-phone-form-field">
          <mat-label data-cy="patient-portal-insurance-phone-label">Phone Number</mat-label>
          <input matInput type="tel" [(ngModel)]="tmpCardObj.InsurancePhone"
            [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-phone-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-insurance-employer-form-field">
          <mat-label data-cy="patient-portal-insurance-employer-label">Employer</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.InsuranceEmployer" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-employer-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-insurance-group-form-field">
          <mat-label data-cy="patient-portal-insurance-group-label">Group</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.InsuranceGroup" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-group-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-insurance-subscriber-id-form-field">
          <mat-label data-cy="patient-portal-insurance-subscriber-id-label">Subscriber ID</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.InsuranceID" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-subscriber-id-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-insurance-subscriber-name-form-field">
          <mat-label data-cy="patient-portal-insurance-subscriber-name-label">Subscriber Name</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.SubscriberName" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-subscriber-name-input">
        </mat-form-field>
        <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-insurance-subscriber-ssn-form-field">
          <mat-label data-cy="patient-portal-insurance-subscriber-ssn-label">Subscriber SSN</mat-label>
          <input matInput [(ngModel)]="tmpCardObj.SubscriberSSN" [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-subscriber-ssn-input">
        </mat-form-field>
        <mat-form-field class="input-field" data-cy="patient-portal-insurance-dob-form-field">
          <mat-label data-cy="patient-portal-insurance-dob-label">Date of Birth</mat-label>
          <input matInput [matDatepicker]="picker2" [(ngModel)]="tmpCardObj.SubscriberDOB"
            [disabled]="tmpCardObj.InsuranceHasInsurance" data-cy="patient-portal-insurance-dob-input">
          <mat-datepicker-toggle matSuffix [for]="picker2" data-cy="patient-portal-insurance-dob-datepicker-toggle"></mat-datepicker-toggle>
          <mat-datepicker #picker2 data-cy="patient-portal-insurance-dob-datepicker"></mat-datepicker>
        </mat-form-field>
      </div>
      @if (!disableSaveButton) {
        <div class="input-field input-field-full" data-cy="patient-portal-insurance-save-actions-container">
          <button mat-raised-button color="primary" class="save-button" (click)="onSavePressed()" data-cy="patient-portal-insurance-save-action-button">Save</button>
        </div>
      }
    </div>
  }

  @if (isLoading) {
    <div class="spinner-container" data-cy="patient-portal-insurance-loading-spinner-container">
      <mat-spinner data-cy="patient-portal-insurance-loading-spinner"></mat-spinner>
    </div>
  }

</div>
